<template>
  <div
    :class="{
      'rounded-14px border border-solid border-www-color-accent-soft bg-www-color-accent-almost-white px-6 py-5': true,
    }"
  >
    <div :class="{ 'mb-3 flex items-center gap-3': true }">
      <DesktopIcon
        :class="{
          'h-6 w-6': true,
        }"
      />
      <span
        :class="{
          'text-15px font-bold text-www-color-neutral-dark': true,
        }"
      >
        {{ label }}
      </span>
    </div>
    <p
      :class="{
        'text-sm font-medium text-www-color-neutral-medium': true,
      }"
    >
      {{ description }}
    </p>
    <Button
      v-if="ctaButton?.text"
      :button-props="ctaButton"
      :class="{
        'mt-18px inline-block w-full': true,
      }"
    />
  </div>
</template>

<script setup lang="ts">
import type { VirtualLocation } from '~/sanity/types';
import Button from '~/components/Atmos/Button/Button.vue';
import DesktopIcon from '~/components/Molecules/EventsComponents/DesktopIcon/DesktopIcon.vue';
defineProps<VirtualLocation>();
</script>
